<div class="sopo-popup-inner-container">
    <div class="sopo-popup-title">{{ header }}</div>
    <div class="sopo-popup-text">{{ body }}</div>

    <div class="sopo-popup-input-container">

        <div class="field-container">
            <div class="field-wrapper" *ngIf="firstNameNeeded">
                <div class="field-label">First Name</div>
                <input
                    class="sopo-popup-input"
                    type="text"
                    [(ngModel)]="form.firstName"
                />
            </div>

            <div class="field-wrapper" *ngIf="birthDateNeeded">
                <div class="field-label">Birth Date</div>
                <ion-datetime-button class="date-time" datetime="birthDatePicker"></ion-datetime-button>

                <ion-modal [keepContentsMounted]="true">
                    <ng-template>
                        <ion-datetime
                            [showDefaultButtons]="true"
                            color="medium"
                            id="birthDatePicker"
                            [(ngModel)]="form.birthDate"
                            presentation="date"
                            [formatOptions]="{
                                date: {
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                }
                            }"
                        >
                        </ion-datetime>
                    </ng-template>
                </ion-modal>
            </div>

            <div class="field-wrapper" *ngIf="ssn4Needed">
                <div class="field-label">Last 4 digits of SSN</div>
                <input
                    class="sopo-popup-input"
                    type="text"
                    [(ngModel)]="form.ssn4"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    maxlength="4"
                />
            </div>
        </div>

    </div>

    <div *ngIf="ageError" class="form-error-message">
        You must be at least 18 years old.
    </div>
    <div *ngIf="missingFieldsError" class="form-error-message">
        Please fill in all required fields.
    </div>
    <div *ngIf="alreadyTried" class="form-error-message">
        The data that you provided did not match our records. Please try again.
    </div>

    <div class="verified-legal-language">
        <img class="verified-logo" src="assets/verified/verified_white.webp">
    </div>

    <div class="sopo-popup-button-container">
        <div class="sopo-popup-green-button ion-activatable clickable" (click)="confirm()">
            CONFIRM
            <ion-ripple-effect></ion-ripple-effect>
        </div>
        <div class="sopo-popup-red-button ion-activatable clickable" (click)="cancel()">
            CANCEL
            <ion-ripple-effect></ion-ripple-effect>
        </div>
    </div>
    @if (showManualSignup) {
        <div class="manually-signup-wrapper">
            <div
                class="manual-signup clickable sopo-popup-green-button ion-activatable"
                (click)="manualSignup()"
            >
                SIGN UP MANUALLY INSTEAD
                <ion-ripple-effect></ion-ripple-effect>
            </div>
        </div>
    }
</div>
